import { useEffect, useState, useCallback, useRef } from "react";
import { supabase } from "@/lib/supabase";

export function useEtapasEstudio() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mounted = useRef(true);

  const fetchData = useCallback(async () => {
    if (!mounted.current) return;
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from("etapas_estudio")
        .select("*")
        .order("orden", { ascending: true });
      if (err) throw err;
      if (mounted.current) {
        setData(result ?? []);
      }
    } catch {
      if (mounted.current) {
        setError("Error cargando etapas");
      }
    } finally {
      if (mounted.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    fetchData();
    return () => {
      mounted.current = false;
    };
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}